module.exports = __webpack_public_path__ + "img/35661-006.93c230d4.jpg";